import _regeneratorRuntime from 'babel-runtime/regenerator';

var _marked = /*#__PURE__*/_regeneratorRuntime.mark(fetchCollection),
    _marked2 = /*#__PURE__*/_regeneratorRuntime.mark(saga);

/**
 * Collections space
 *
 * The logic for collections.
 *
 * What is known:
 * - Collections can contain manifests
 * - Collections can contain other collections
 *
 * Interactions:
 * - When collection is selected, it should be loaded if its not already.
 *
 * Needs planning:
 * - Next/Prev
 */
import { put, all, takeEvery } from 'redux-saga/effects';
import { ROUTING_SELECT_COLLECTION } from './routing';
import { collection } from '../schema/presentation2';
import { iiifResourceRequest } from './iiif-resource';

var COLLECTION_REQUEST = 'COLLECTION_REQUEST';
var COLLECTION_SUCCESS = 'COLLECTION_SUCCESS';
var COLLECTION_ERROR = 'COLLECTION_ERROR';

function fetchCollection(_ref) {
  var id = _ref.payload.id;
  return _regeneratorRuntime.wrap(function fetchCollection$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return put(iiifResourceRequest(id, [COLLECTION_REQUEST, COLLECTION_SUCCESS, COLLECTION_ERROR], collection));

        case 2:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

function saga() {
  return _regeneratorRuntime.wrap(function saga$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return all([takeEvery(ROUTING_SELECT_COLLECTION, fetchCollection)]);

        case 2:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

export { COLLECTION_SUCCESS, COLLECTION_REQUEST, COLLECTION_ERROR, saga };